import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_LABORATORY_ID,
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_ID,
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_FAILURE,
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_SUCCESS,

    ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE,
    ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_SUCCESS,
    ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_FAILURE,

    ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE,
    ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_SUCCESS,
    ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_FAILURE,

    ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE,
    ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_SUCCESS,
    ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_FAILURE,

    ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE,
    ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_SUCCESS,
    ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_FAILURE,

    ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC,
    ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_SUCCESS,
    ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_FAILURE,

    ACTION_LABORATORYCONFIDENTIALITYDEED_CLEAR,
    ACTION_LABORATORYCONFIDENTIALITYDEED_FILTER,

    LaboratoryConfidentialityDeedAction
} from '../actions/laboratoryConfidentialityDeed';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ILaboratoryConfidentialityDeedState {
    formData: Dtos.LaboratoryConfidentialityDeed | Dtos.LaboratoryConfidentialityDeed[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    validateState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    deleteState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.LaboratoryConfidentialityDeed[];
    formLength: number;
}

const initialState: ILaboratoryConfidentialityDeedState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    deleteState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ILaboratoryConfidentialityDeedState, _isLoading: boolean): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ILaboratoryConfidentialityDeedState,
    formData: Dtos.LaboratoryConfidentialityDeed | Dtos.LaboratoryConfidentialityDeed[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: ILaboratoryConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: ILaboratoryConfidentialityDeedState, formFilter: IFormFilter): ILaboratoryConfidentialityDeedState {

    const items: Dtos.LaboratoryConfidentialityDeed[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (
            formFilter.search == "" ||
            p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1
        )) : undefined;

    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: ILaboratoryConfidentialityDeedState, propertiesToClear?: string[]): ILaboratoryConfidentialityDeedState {

    if (!propertiesToClear) {
        const newState: ILaboratoryConfidentialityDeedState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ILaboratoryConfidentialityDeedState, _isSaving: boolean): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ILaboratoryConfidentialityDeedState,
    formData: Dtos.LaboratoryConfidentialityDeed | Dtos.LaboratoryConfidentialityDeed[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ILaboratoryConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function validating(state: ILaboratoryConfidentialityDeedState, _isValidating: boolean): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ILaboratoryConfidentialityDeedState,
    formData: Dtos.LaboratoryConfidentialityDeed | Dtos.LaboratoryConfidentialityDeed[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ILaboratoryConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ILaboratoryConfidentialityDeedState, _isCreating: boolean): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ILaboratoryConfidentialityDeedState,
    formData: Dtos.LaboratoryConfidentialityDeed,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ILaboratoryConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function deleting(state: ILaboratoryConfidentialityDeedState, _isDeleting: boolean): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function deleteSuccess(
    state: ILaboratoryConfidentialityDeedState,
): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function deleteFailure(state: ILaboratoryConfidentialityDeedState, responseStatus: Dtos.ResponseStatus): ILaboratoryConfidentialityDeedState {
    const newState: ILaboratoryConfidentialityDeedState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

const LaboratoryConfidentialityDeedReducer: Reducer<ILaboratoryConfidentialityDeedState> = (state: ILaboratoryConfidentialityDeedState = initialState, action: LaboratoryConfidentialityDeedAction) => {
    switch (action.type) {
        case ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_LABORATORY_ID:
        case ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE:
            return saving(state, true);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE:
            return validating(state, true);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE:
            return creating(state, true);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE:
            return deleting(state, true);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_SUCCESS:
            return deleteSuccess(state);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE_FAILURE:
            return deleteFailure(state, action.responseStatus);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_FILTER:
            return filter(state, action.formFilter);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC:
            return loading(state, true);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_LABORATORYCONFIDENTIALITYDEED_SYNC_FAILURE:
            return loadFailure(state, action.responseStatus);

    }

    return state;
}

export default LaboratoryConfidentialityDeedReducer;